module.exports = __webpack_public_path__ + "img/icon-vot-startvoting.b6a7546f.png";